import { render } from "./HeroAuthDashboardContent.vue?vue&type=template&id=776b64c8&scoped=true"
import script from "./HeroAuthDashboardContent.vue?vue&type=script&lang=js"
export * from "./HeroAuthDashboardContent.vue?vue&type=script&lang=js"

import "./HeroAuthDashboardContent.vue?vue&type=style&index=0&id=776b64c8&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776b64c8"]])

export default __exports__